import {AppState} from "../app";
import {ImageRenderer} from "../components/image/imageRenderer";
import {Sprite} from "../engine/tools/SpriteLoader";
import {GrabAnchor} from "../components/grab/grabAnchor";


const debug = false
const debugAnchors = false

const missingSprites = []


export function draw({interactiveCanvas, entities, spriteDatabase, soundEvents}: AppState) {

    const {ctx} = interactiveCanvas

    interactiveCanvas.ctx.imageSmoothingEnabled = false;
    interactiveCanvas.prepareForRender()

    entities.forEach([ImageRenderer], (e) => {

        if (!e.ImageRenderer.sprite)
            return

        const sprite = spriteDatabase.sprites[e.ImageRenderer.sprite] as Sprite
        if (!sprite) {

            if (missingSprites.indexOf(e.ImageRenderer.sprite) === -1) {

                missingSprites.push(e.ImageRenderer.sprite)
                console.log(`sprite '${e.ImageRenderer.sprite}' not loaded, trying to load it...`, e)

                spriteDatabase.loadSprites(e.ImageRenderer.sprite).then(s=>{
                    console.log(`${s} loaded.`)
                })
            }

            return
        }

        ctx.save()
        if (e.Position)
            ctx.translate(e.Position.value.x, e.Position.value.y)
        if (e.Rotation)
            ctx.rotate(e.Rotation.value);
        if(sprite.scale !== 1)
            ctx.scale(sprite.scale,sprite.scale);
        if(e.Scale)
            ctx.scale(e.Scale.value.x,e.Scale.value.y);

        if (debug) {
            ctx.globalAlpha = 0.1
            ctx.save()
            ctx.beginPath()
            ctx.fillStyle = "green"
            ctx.ellipse(0, 0, 10, 10, 0, 0, Math.PI * 2)
            ctx.fill()
            ctx.restore()
        }
        let w,h,x,y
        if(sprite.file.frame)
        {
            w = sprite.file.frame.w
            h = sprite.file.frame.h
            x = sprite.file.frame.x
            y = sprite.file.frame.y
        }
        else{

            w = sprite.file.image.width
            h = sprite.file.image.height
            x = 0
            y = 0
        }
        ctx.translate(-sprite.pivot.x * w, -sprite.pivot.y * h)

        if (debug) {
            ctx.save()
            ctx.beginPath()
            ctx.fillStyle = "red"
            ctx.rect(0, 0, w,h)
            ctx.fill()
            ctx.restore()
        }
        ctx.scale(1, -1)
        ctx.drawImage(sprite.file.image, x,y,w,h,0, -h,w,h)
        ctx.restore()
    })

    if (debugAnchors) {
        entities.forEach([GrabAnchor], (e) => {

            ctx.save()
            if (e.Position)
                ctx.translate( e.GrabAnchor.target.Position.value.x, e.GrabAnchor.target.Position.value.y)

            ctx.beginPath()
            ctx.fillStyle = "green"
            ctx.ellipse(0, 0, 10, 10, 0, 0, Math.PI * 2)
            ctx.fill()

            ctx.restore()
        })
    }
}